export enum LocationStatusEnum {
  LIVE = 0,
  STORAGE = 1,
  DEFAULT = 2,
}
